import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["hero", "loader", "categories"];

  initialize() {
    this.handleBlog();
  }

  async handleBlog() {
    const data = await fetch("/pages/editorial-hub");
    const content = await data.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");

    this.loaderTarget.classList.add("hidden");

    const carousel = doc.querySelector("#hero-carousel");
    const nav = doc.querySelector(".js-editorial-nav");

    if (carousel) {
      this.heroTarget.innerHTML = `
        <div
          class="hero splide splide--main"
          data-splide='{ "perPage": 1, "pagination": true }'
        >
          ${carousel.innerHTML}
        </div>
      `;
      this.heroTarget.dataset.controller = "carousel";
    }

    if (nav && this.hasCategoriesTarget) {
      this.categoriesTarget.innerHTML = nav.innerHTML;
    }
  }

  parseHtml(html) {
    return new DOMParser().parseFromString(html, "text/html").body;
  }
}
